import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import PasswordResetForm from "./PasswordResetForm"
import { resetPassword } from "../../redux/actions/authActions"
import Spinner from "../common/Spinner";
import { toast } from "react-toastify";


function PasswordResetPage({
    auth,
    errorMessage,
    resetPassword,
    history,
    ...props
}) {

    const [reset, setReset] = useState({ ...props.reset });
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (auth.isAuthenticated) {
            history.push("/login");
        }
        document.title = "Reset Password | JustGoRide";
        //pull code from querystring
        var urlParams = new URLSearchParams(window.location.search);
        var resetCode = urlParams.get('code');
        setReset(prevReset => ({
            ...prevReset,
            code: resetCode
        }));

    }, []);

    function formIsValid() {
        const errors = {};
        var isValid = true;

        if (!reset.code) {
            setErrors({ onResetPassword: "Password reset code missing, please request a new password reset email and follow the link within the email." });
            //user should not be here so ignore further validation
            return false;
        }

        if (!reset.email) {
            errors.email = "Email address is required.";
            setErrors(errors);
            isValid = false;
        }else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(reset.email)) {
            errors.email = "Email address format invalid.";
            setErrors(errors);
            isValid = false;
        }

        if (!reset.password) {
            errors.password = "You must specify a password.";
            setErrors(errors);
            isValid = false;
        }

        if (!reset.passwordConfirmation) {
            errors.passwordConfirmation = "You must confirm the password.";
            setErrors(errors);
            isValid = false;
        }

        if (reset.password !== reset.passwordConfirmation) {
            errors.passwordConfirmation = "The passwords must match.";
            setErrors(errors);
            isValid = false;
        }

        var passwordStrength = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        if (!passwordStrength.test(reset.password)) {
            errors.password = "Password must be at least 8 characters in length, contain upper and lowercase letters and at least one number.";
            setErrors(errors);
            isValid = false;
        }
        return isValid;
    }

    function handleChange(event) {
        const { name, value } = event.target;
        setReset(prevReset => ({
            ...prevReset,
            [name]: value
        }));
    }

    function handleReset(event) {
        event.preventDefault();

        if (!formIsValid()) return;

        setProcessing(true);
        
        resetPassword(reset).then((auth) => {
            toast.success("Password reset!");
            history.push("/");
        })
        .catch(error => {
            setProcessing(false);
            setErrors({ onResetPassword: error.message });
        });

        
    }

    return (
        <div className="jgr-password-reset">
            {processing ?
                <Spinner /> :
                (
                    <PasswordResetForm
                        email={reset.email}
                        password={reset.password}
                        passwordConfirmation={reset.passwordConfirmation}
                        errors={errors}
                        onChange={handleChange}
                        onReset={handleReset}
                        processing={processing}
                    />
                )
            }
        </div>
    );

}

PasswordResetPage.propTypes =
    {
        reset: PropTypes.object.isRequired,
        resetPassword: PropTypes.func.isRequired,
        auth: PropTypes.object.isRequired,
        errorMessage: PropTypes.string
    }


function mapStateToProps(state) {
    return {
        reset: { email: "", password: "", passwordConfirmation: "" },
        auth: state.auth
    };
}

const mapDispatchToProps = {
    resetPassword
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetPage); 


// WEBPACK FOOTER //
// ./src/components/user/PasswordResetPage.js